export default "__VITE_ASSET__BqBoHoaN__"